const deviceType = IsPC()?'pc':'mobile'
const host = process.env.NODE_ENV == 'development' ? 'http://172.30.1.101:9000/' : 'https://api-moss.17m3.com/';
const webUrl = process.env.NODE_ENV == 'development' ? 'http://192.168.217.171:9527/' : 'https://www.m3guo.com/activity/202312/gic0f09ce/';
const domain = deviceType == 'pc' ? webUrl + 'index.html' : webUrl + 'm.html';

const activityTime = '9月1日-9月28日';

const getQueryVariable = function (variable) {
    var query = window.location.search.substring(1) || window.location.hash.substring(1);
    var vars = query.split("&");

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
        return pair[1];
        }
    }
    return '';
}

const wx_share_text = {
  title: '星宿争辉 老兵请战', // 分享标题
  desc: '征战世无双，回归享好礼！', // 分享描述
  imgUrl: 'https://web-resource.17m3.com/m3guo/202312/game-invite/300.jpg', // 分享图标   
}

const issn = '12';

const ajax_url_map = {
  login : host + 'api/login/authorize?callbackurl=' + encodeURIComponent(domain) + '&issn=' + issn,
  logout : '',
  free : host + 'api/login/kouDai',
  logininfo : host + 'api/user/getLoginInfo',
  userinfo : host + 'api/recruit/getUserInfo',
  queryplayer : host + 'api/user/getNickName',
  bind : host + 'api/user/bind',
  draw_list : host + 'api/gift/drawList',//获取抽奖列表
  share_config : host + 'api/share/GetConfigs',//获取邀请配置
  share_apply : host + 'api/share/reward',//手动领取分享奖励
  getcode : host + 'api/share/getInviteCode',//获取邀请码
  lottery : host + 'api/gift/draw',//抽奖
  buy : host + 'api/gift/buy',//购买
  record_list : host + 'api/gift/userGiftList?pageIndex=1&pageSize=0',//record
  apply : host + 'api/gift/achieve',//直接领取道具 type=1 //登录领取 type=2 //章节基金礼 一键领取 type=3&giftId=1 //礼包1领取 type=3&giftId=2 //礼包2领取 type=3&giftId=3 //礼包3领取
  unlock : host + 'api/gift/unlock',//599解锁
  friend_list : host + 'api/share/getList',//好友列表
  invite : host + 'api/share/getCode',//获取邀请码
  apply_invite : host + 'api/share/bindCode',//绑定邀请码
  invite_info : host + 'api/share/getNickName',//获取昵称信息
  share_apply : host + 'api/share/reward',//手动领取分享奖励
  task_info : host + 'api/UserTask/GetList',//积分奖励
  task_apply : host + 'api/UserTask/RwTaskId',//领取奖励
  tips : 'https://tool.m3guo.com/api/web/m3goods/eq-item/',//tip获取
  mplat : host + 'api/login/mplat',//梦平台免登录
  queryscore : host + 'api/chicken/queryScore',//军威值查询
}


const cleanArray = function (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

const param =  function (json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined)
      return ''
    return encodeURIComponent(key) +
    '=' + encodeURIComponent(json[key])
  })).join('&')
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
      }
  }
  return flag;
}

const areaList = [{
  "id": 1,
  "name": "火烧赤壁"
}, {
  "id": 2,
  "name": "草船借箭"
}, {
  "id": 6,
  "name": "荆州之战"
}, {
  "id": 7,
  "name": "青梅煮酒"
}, {
  "id": 11,
  "name": "九伐中原"
}, {
  "id": 16,
  "name": "怀旧服"
}, {
  "id": 8,
  "name": "官渡之战"
}, {
  "id": 9,
  "name": "桃园结义"
}, {
  "id": 19,
  "name": "火凤燎原"
}, {
  "id": 20,
  "name": "卧龙出渊"
},
{
  "id": 21,
  "name": "长生殿(Steam)"
}, {
  "id": 23,
  "name": "单刀赴会"
},{
  "id": 22,
  "name": "逍遥津</br>(wegame3)"
},
{
  "id": 17,
  "name": "铜雀台(wegame1)"
}, {
  "id": 18,
  "name": "凤仪亭(wegame2)"
}, {
  "id": 100,
  "name": "TEST_1"
}, {
  "id": 110,
  "name": "TEST_2"
}
]

const queryArea = function (num){
  var area = '暂无大区信息';

  if (num == 1) {
      area = '火烧赤壁';
  } else if (num == 2) {
      area = '草船借箭';
  } else if (num == 6) {
      area = '荆州之战';
  } else if (num == 7) {
      area = '青梅煮酒';
  } else if (num == 8) {
      area = '官渡之战';
  } else if (num == 9) {
      area = '桃园结义';
  } else if (num == 11) {
      area = '九伐中原';
  } else if (num == 12) {
      area = '逐鹿中原';
  } else if (num == 13) {
      area = '三分天下';
  } else if (num == 16) {
      area = '怀旧服';
  }else if (num == 17) {
      area = '铜雀台';
  } else if (num == 18) {
      area = '凤仪亭';
  }else if (num == 19) {
      area = '火凤燎原';
  }else if (num == 20) {
      area = '卧龙出渊';
  }else if (num == 21) {
      area = '长生殿';
  }else if (num == 22) {
    area = '逍遥津';
  }else if (num == 23) {
    area = '单刀赴会';
  }else if (num == 100 || num == 101) {
      area = '测试大区';
  }

  return area;
}


export default {
    host,
    ajax_url_map,
    getQueryVariable,
    domain,
    param,
    deviceType,
    areaList,
    issn,
    activityTime,
    wx_share_text,
    queryArea,
}


// WEBPACK FOOTER //
// ./src/assets/js/global.js